import {SendbirdChatWith} from '@sendbird/chat'
import {GroupChannel, GroupChannelModule} from '@sendbird/chat/groupChannel'
import {SendbirdPanel} from '@/stores'

export const SendbirdChatContainerStoreSymbol = Symbol('SendbirdChatContainerStore')

export interface ISendbirdChatStore {
    merchantId: string
    publicId: string
    nickname: string
    isInitialized: boolean
    sb: SendbirdChatWith<GroupChannelModule[]>
    initializeSendbirdChat: () => void
    setCurrentChannel: (channel: GroupChannel) => void
    currentChannel: GroupChannel
    open: boolean
    setOpen: (open: boolean) => void
    createNewChannel: () => Promise<GroupChannel>
    currentChannelUrl: string
    setCurrentChannelUrl: (currentChannelUrl: string) => void
    panel: SendbirdPanel
    setPanel: (panel: SendbirdPanel) => void
    dispose: () => Promise<void>
}
